<div class="alert-modal" [ngClass]="'it-' + intent">

  <div class="confirm-head">
    <div class="badge-ico">
      <i class="bi" [ngClass]="iconClass"></i>
    </div>
    <div class="htext">
      <h3 class="alert-title">{{ title }}</h3>
      <p class="alert-message">{{ data.message }}</p>
    </div>
    <button type="button" class="close-btn" (click)="onClose('no')" aria-label="Close">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <div class="alert-actions">
    <button type="button" class="btn btn-secondary" (click)="onClose('no')">
      {{ data.noAction }}
    </button>
    <button type="button" class="btn"
            [ngClass]="{
              'btn-danger': intent === 'danger',
              'btn-warning': intent === 'warning',
              'btn-primary': intent === 'info'
            }"
            (click)="onClose('yes')">
      {{ data.yesAction }}
    </button>
  </div>
</div>
